import {
  Profession,
  IProfessionRepository,
} from "../../../domain/user";
import {
  AuthenticatedCachedRepository,
  AuthenticatedHttpClient,
} from "../..";
import { IProfessionBean } from "./beans";

export class ProfessionRepository extends AuthenticatedCachedRepository<string, Profession> implements IProfessionRepository {
  constructor(getToken: () => string) {
    super(new AuthenticatedHttpClient(getToken), ProfessionRepository.createCache);
  }

  private static async createCache(client: AuthenticatedHttpClient): Promise<Profession[]> {
    const url = "/api/professions";
    const result = await client.get(url);
    return ProfessionRepository.toProfessions(result.data);
  }

  private static toProfessions(professions: IProfessionBean[]): Profession[] {
    const results: Profession[] = [];
    for (const profession of professions) {
      results.push(ProfessionRepository.toProfession(profession));
    }
    return results;
  }

  private static toProfession(bean: IProfessionBean): Profession {
    return bean !== null
      ? new Profession(
          bean.id,
          bean.name,
          bean.category
        )
      : null; 
  }
}
